<template>
  <el-dialog class="k-user-edit-challenge-form" title="Редактирование челленджа" z-i:close-on-click-modal="false" :center="true" :show-close="false" :visible.sync="dialogFormVisible">
    <div class="k-user-edit-challenge-form__container">

      <el-row :gutter="20" class="k-user-edit-challenge-form__param">
        <el-col :span="8" class="k-user-edit-challenge-form-form__label">Название:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="challenge.name"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-user-edit-challenge-form__param">
        <el-col :span="8" class="k-user-edit-challenge-form-form__label">Сумма:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="challenge.amount"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-user-edit-challenge-form__param">
        <el-col :span="8" class="k-user-edit-challenge-form-form__label">Описание:</el-col>
        <el-col :span="16"><el-input placeholder="Название" v-model="challenge.description" type="textarea"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="k-user-edit-challenge-form__param">
        <el-button type="success" round @click="handleSave" size="mini">Сохранить</el-button>
        <el-button round @click="handleCancel" size="mini">Отмена</el-button>
      </el-row>
    </div>
    <div v-if="loader" class="overlay">
      <div class="el-icon-loading loader"></div>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'k-challenge-update-form',

  props: {
    dialogFormVisible: {
      type: Boolean,
      required: true,
    },
    challenge: {
      type: Object,
    },
  },

  data() {
    return {
      loader: false,
    };
  },

  methods: {
    // Отмена редактирования
    handleCancel() {
      this.$emit('cancel');
    },

    // Сохранение
    async handleSave() {
      this.loader = true;
      this.setChallenge({
        id: this.challenge.id,
        name: this.challenge.name,
        description: this.challenge.description,
        amount: this.challenge.amount,
      });

      this.loader = false;
      this.$emit('cancel');
    },

    ...mapActions({
      setChallenge: 'challenges/setChallenge',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.k-user-edit-challenge-form {
  $this: &;
  $icon-size: 50px;
  z-index: 2100;
  text-align: left;

  &__container {
    padding: 0 20px;
  }

  &__param {
    margin-bottom: $vp;
    margin: 10px 0;

    textarea {
      font-family: 'Open Sans', sans-serif;
    }
  }

  .loader {
    position: absolute;
    font-size: 100px;
    top: 40%;
    left: 45%;
    color: white;
  }

  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #00000094;
  }
}
</style>
